<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{name:'MemberHomeworkIndex'}">我的作业</router-link>
      <span class="slash">/</span>
      <span class="current">查看详情</span>
    </div>
    <div class="main-content clearfix">
      <div class="f-left">
        <div class="hw-wrap">
          <div class="hw-name">{{scantron.hw_name}}</div>
          <div class="hw-info">
            <div class="item">
              <label class="label">截止时间：</label>
              <span class="text">{{scantron.end_time|tsFormatLong}}</span>
            </div>
            <div class="item">
              <label class="label">题目总数：</label>
              <span class="text">{{scantron.ques_count}}</span>
            </div>
            <div class="item">
              <label class="label">作业总分：</label>
              <span class="text">{{scantron.is_set_score==2?scantron.score:"-"}}</span>
            </div>
          </div>
        </div>
        <Question
          v-if="current"
          :ques="current"
          :answer="answer"
          :showOperate="false"
          shotAnswerEditable
          :answerImg="answerImg"
          :showScore="scantron.is_set_score==2"
          @change="onChange(current)"
          @addImg="addImg"
          @deleteImg="deleteImg"
        ></Question>
      </div>
      <div ref="rightWrap" class="f-right" :style="style">
        <HomeworkDoRight
          ref="right"
          :reportId="id"
          :scantron="scantron"
          :answer="answer"
          :answerImg="answerImg"
          @topicChange="onTopicChange"
          @submit="submit"
        ></HomeworkDoRight>
      </div>
    </div>
    <el-dialog class="dialog" :visible.sync="showTipDialog" width="480px">
      <div class="body">
        <i class="el-icon-warning"></i>
        <span>距离作业截止提交时间只剩{{surplusMinutes}}分钟，请注意答题时间。</span>
      </div>
      <template v-slot:footer>
        <el-button type="primary" @click="showTipDialog = false">我知道了</el-button>
      </template>
    </el-dialog>
    <el-dialog
      class="dialog"
      :visible.sync="showSubmitDialog"
      :close-on-click-modal="false"
      width="480px"
    >
      <div class="body">
        <i class="el-icon-warning"></i>
        <span>作业截止提交时间已到，系统已为您自动提交作业。</span>
      </div>
      <template v-slot:footer>
        <el-button type="primary" @click="showSubmitDialog = false;goBack();">我知道了</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import Question from "@/components/ques/Question.vue";
import HomeworkDoRight from "./components/HomeworkDoRight.vue";
export default {
  name: "HomeworkDo",
  components: {
    Question,
    HomeworkDoRight
  },
  data() {
    return {
      id: this.$route.query.id,
      index: 1,
      answer: {},
      current: {},
      scantron: {},
      surplusMinutes: 0,
      showTipDialog: false,
      hasShowTip: false,
      timer: null,
      showSubmitDialog: false,
      answerImg: {},
      hasScroll: false,
      fixed: 0,
      fixedRight: 0
    };
  },
  computed: {
    style() {
      let style = {};
      style.right = this.fixedRight + "px";
      if (this.fixed == 1) {
        style.position = "fixed";
        style.top = "70px";
      } else if (this.fixed == 2) {
        style.position = "absolute";
        style.bottom = "0";
      }
      return style;
    }
  },
  async created() {
    this.timer = setInterval(async () => {
      if (this.scantron.end_time * 1000 - new Date().getTime() <= 0) {
        clearInterval(this.timer);
        this.$refs.right.$refs.right.submit(true);
      }
    }, 1000);
    await this.getTopicStatus();
    this.$nextTick(() => {
      this.$refs.right.init(this.index);
    });
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener("scroll", this.setFixed);
      document.addEventListener("resize", this.setFixed);
    });
  },
  destroyed() {
    document.removeEventListener("scroll", this.setFixed);
    document.removeEventListener("resize", this.setFixed);
  },
  methods: {
    setFixed() {
      let $ = window.$;
      let scrollTop = $(document.documentElement).scrollTop();
      if (scrollTop > 48) {
        let footerOffset = $("#footerBar").offset();
        let rightHeight = this.$refs.rightWrap.clientHeight;
        if (footerOffset.top - rightHeight - scrollTop < 100) {
          this.fixed = 2;
          this.fixedRight = 0;
        } else {
          this.fixed = 1;
          this.fixedRight = ($(window).width() - 1200) / 2;
          if (this.fixedRight < 0) {
            this.fixedRight = 0;
          }
        }
      } else {
        this.fixed = 0;
      }
    },
    async getTopicStatus() {
      let data = await this.$http.post("/api/app/user/homework/scantron", {
        report_id: this.id
      });
      let flag = false;
      let answerCount = data.list.filter(t => t.status == 1 || t.status == 2)
        .length;
      data.list.forEach((t, index) => {
        if (answerCount > 0 && !flag && t.status == 3) {
          this.index = Math.min(data.list.length, index + 1);
          flag = true;
        }
      });
      this.scantron = data;
    },
    onTopicChange(ques) {
      this.hasScroll = false;
      if (!this.hasShowTip) {
        let surplus = this.scantron.end_time * 1000 - new Date().getTime();
        if (surplus <= 30 * 60 * 1000) {
          this.showTipDialog = true;
          this.surplusMinutes = parseInt(surplus / 1000 / 60);
          this.hasShowTip = true;
        }
      }
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        this.$set(this.answer, ques.question_id, ques.user_answer);
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        this.$set(
          this.answer,
          ques.question_id,
          ques.user_answer
            ? ques.user_answer.split(",").map(s => Number(s))
            : []
        );
      } else if (ques.ques_type == 5) {
        if (ques.user_answer) {
          let user_answer = JSON.parse(ques.user_answer);
          this.$set(this.answer, ques.question_id, user_answer.content);
          this.$set(this.answerImg, ques.question_id, user_answer.images);
        }
      }
      this.current = ques;
    },
    onChange(ques) {
      let scantronQues = this.scantron.list.find(
        q => q.question_id == ques.question_id
      );
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        if (this.answer[ques.question_id]) {
          scantronQues.status = 1;
          this.$refs.right.navNext();
        }
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        if (this.answer[ques.question_id].length > 0) {
          scantronQues.status = 1;
        } else {
          scantronQues.status = 3;
        }
      } else if (ques.ques_type == 5) {
        if (
          this.answer[ques.question_id] ||
          (this.answerImg[ques.question_id] || []).length > 0
        ) {
          scantronQues.status = 1;
        } else {
          scantronQues.status = 3;
        }
      }
    },
    goBack() {
      this.$store.dispatch("refreshHomeworkState");
      this.$router.replace({
        name: "MemberHomeworkIndex"
      });
    },
    submit({ autoSubmit }) {
      if (autoSubmit) {
        this.showSubmitDialog = true;
      } else {
        this.goBack();
      }
    },
    addImg(ques, path) {
      let images = this.answerImg[ques.question_id] || [];
      images.push(path);
      this.$set(this.answerImg, ques.question_id, images);
    },
    deleteImg(ques, index) {
      this.answerImg[ques.question_id].splice(index, 1);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style lang="scss" scoped>
.main-content {
  margin-bottom: 30px;
  position: relative;
  > .f-left {
    width: 890px;
    background-color: white;
    border-radius: 5px;
  }
  > .f-right {
    width: 290px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    padding: 19px 20px;
    box-sizing: border-box;
  }
}
.hw-wrap {
  padding: 0 30px;
  .hw-name {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 1;
    padding: 31px 0 27px 0;
  }
  .hw-info {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding-bottom: 26px;
    border-bottom: 1px dashed #dbdbdb;
    padding-left: 2px;

    .label {
      color: #999999;
    }

    .item {
      &:first-child {
        margin-right: 152px;
      }
      &:nth-child(2) {
        margin-right: 187px;
      }
    }
  }
}
.dialog {
  /deep/ {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__footer {
      padding: 0 0 20px 0;
      text-align: center;
    }
    .el-dialog__body {
      font-size: 16px;
      color: #333;
      padding: 37px 0 70px 0;
      text-align: center;
    }
  }
  .el-icon-warning {
    color: #f18b07;
    font-size: 20px;
    margin-right: 7px;
  }
  .body {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>